import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import Game from './Game';

export default class IntroScreen extends Phaser.Scene {
  static get KEY() { return 'IntroScreen'; }

  constructor() {
    super({ key: IntroScreen.KEY });
  }

  create() {
    const width = this.scale.width;
    const height = this.scale.height;

    // background
    ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._open_background, this).setOrigin(0);

    // chest top
    ABCyaPhaser.Images.addImage(this.scale.width / 2 - 10, this.scale.height / 2 + 140 - 25, UIAssetKeys._chest_top, this);

    // chest lock
    ABCyaPhaser.Images.addImage(this.scale.width / 2 - 10, this.scale.height / 2 + 290, UIAssetKeys._chest_lock, this);

    this.title = ABCyaPhaser.Images.addImage(width / 2, height / 2 - 100, UIAssetKeys._title, this).setScale(0)
      .setAlpha(0);
    ABCyaPhaser.Tweens.addTween(this.title, 1100, { delay: 200, scale: 1 }, Phaser.Math.Easing.Bounce.Out);
    ABCyaPhaser.Tweens.addTween(this.title, 1100, { delay: 200, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);

    this.titleSound = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._title, this.titleSound);

    this.time.delayedCall(1300, this.makeLetters, null,this);
  }

  makeLetters () {
    for (let i = 0; i < 7; i++) {
      const dark = ABCyaPhaser.Images.addImage(0,0,`let-${i + 1}`, this).setOrigin(0);
      const light = ABCyaPhaser.Images.addImage(0,0,`let-${i + 1}b`, this).setOrigin(0);
      dark.alpha = 0;
      light.alpha = 0;

      let y = this.scale.height / 2 - 46; ;
      const x = this.scale.width / 2 - 342 + i * 96;
      if ((i + 1) % 2 === 0) {
        y = this.scale.height / 2 + 4;
      }

      dark.x = x;
      dark.y = y;
      light.x = x;
      light.y = y;

      ABCyaPhaser.Tweens.addTween(dark, 300, { delay: i * 150, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
        this.blinkLights(dark, light);
      });
    }

    this.goButton = ABCyaPhaser.Images.addImage(this.scale.width / 2 + 20 - 900, this.scale.height / 2 + 250, UIAssetKeys._play_button, this).setInteractive()
      .on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.cleanUp, this);
    ABCyaPhaser.Tweens.addTween(this.goButton, 1300, { delay: 500, x: this.goButton.x + 900 }, Phaser.Math.Easing.Bounce.Out, () => this.shrinkGrow(this.goButton));
  }

  blinkLights (dark, light) {
    ABCyaPhaser.Tweens.addTween(dark, 800, { alpha: 0.5 }, Phaser.Math.Easing.Quadratic.Out, () => {
      ABCyaPhaser.Tweens.addTween(dark, 200, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
        this.blinkLights(dark, light);
      });
    });

    ABCyaPhaser.Tweens.addTween(light, 200, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
      ABCyaPhaser.Tweens.addTween(light, 800, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
    });
  }

  cleanUp () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
    this.tweens.killAll();
    this.titleSound.destroy();
    this.titleSound = null;
    this.scene.start(Game.KEY);
  }

  shrinkGrow (button) {
    ABCyaPhaser.Tweens.addTween(button, 500, { scale: 0.9 }, Phaser.Math.Easing.Quadratic.Out, () => {
      ABCyaPhaser.Tweens.addTween(button, 500, { scale: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
        this.shrinkGrow(button);
      });
    });
  }
}